import {
  LaunchOutlined as LaunchIcon,
  LocalShipping as ServiceIcon,
} from '@mui/icons-material';

interface CardIdentifierProps {
  index: number;
  shippingNumber: string;
  serviceType: string | undefined;
  onOpenDetails: () => void;
}

const CardIdentifier = ({
  index,
  shippingNumber,
  serviceType,
  onOpenDetails,
}: CardIdentifierProps) => {
  return (
    <div className='flex items-center gap-4 flex-1'>
      <div className='w-12 h-12 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center font-black text-base'>
        {index}
      </div>
      <div className='flex flex-col'>
        <span
          onClick={onOpenDetails}
          className='font-black text-[#2196f3] hover:text-[#1976d2] text-xl leading-tight cursor-pointer transition-colors flex items-center gap-1.5'
          title='Ver detalle del envío'
        >
          <LaunchIcon sx={{ fontSize: 18 }} />
          {shippingNumber}
        </span>
        {serviceType && (
          <div className='flex items-center gap-1.5 text-sm text-gray-400 font-bold mt-0.5'>
            <ServiceIcon sx={{ fontSize: 16 }} />
            {serviceType}
          </div>
        )}
      </div>
    </div>
  );
};

export default CardIdentifier;
